import { erpAxios } from '..';

const getProcjenaRizika = async (brojZahtjeva) => {
  const { data } = await erpAxios.get(`/procjenaRizika/${brojZahtjeva}`);
  return data;
};

export default getProcjenaRizika;
